import Environment from "src/Configs/Environments";

export const APPLICATION_NAME = Environment?.httpService?.applicationName;

export const GOOLGE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY || "";

export const DEFAULT_RESTAURANT_BRAND_COLOR = "#FD5B5B";

export const DEFAULTR_BRAND_COLOR = "#FD5B5B";

export const jsDayMappings = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
];

// Limits
// All the Characters  limits are given below

export const MODIFIER_MAX_LENGTH = 140;
